<div
  class="d-flex justify-content-center align-items-center height d-flex flex-column">
  <mat-icon class="icon-display text"> access_time </mat-icon>
  <p class="h5 text pt-4 font-weight-bold">
    {{ 'withdraw.alertReviewKyc' | translate }}
  </p>
</div>
